const audiences = [
  {
    icon: 'ri-user-add-line',
    tag: '初次接触',
    title: '第一次用，跟着走就好',
    points: ['下载入口集中摆放，不用来回找', '安装指引按机型说清放行步骤', '默认设置已调好，上手即可用'],
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20of%20a%20friendly%20first%20time%20mobile%20app%20user%2C%20simple%20rounded%20character%20silhouette%20beside%20a%20large%20smartphone%2C%20soft%20warm%20cream%20background%2C%20minimal%20geometric%20shapes%2C%20warm%20amber%20accents%2C%20editorial%20illustration%2C%20clean%20airy%2C%20no%20text&width=900&height=640&seq=91br-audience-new&orientation=landscape',
  },
  {
    icon: 'ri-history-line',
    tag: '老用户升级',
    title: '旧版换新版，数据别丢',
    points: ['覆盖安装即可，书签与记录保留', '升级后旧版卡顿问题同步修复', '支持版本回退，用不惯也能换回'],
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20of%20upgrading%20a%20mobile%20application%20to%20the%20latest%20version%2C%20upward%20floating%20geometric%20panels%20and%20a%20subtle%20refresh%20symbol%2C%20soft%20warm%20neutral%20background%2C%20minimal%20composition%2C%20amber%20and%20green%20accents%2C%20editorial%20technology%20illustration%2C%20clean%2C%20no%20text&width=900&height=640&seq=91br-audience-upgrade&orientation=landscape',
  },
];

export default function AudienceSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 xl:px-14">
        <div className="max-w-2xl reveal reveal-1">
          <span className="text-xs md:text-sm font-medium text-accent-700 tracking-wide">
            适用人群
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            哪种情况更贴近你
          </h2>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-7">
          {audiences.map((a, idx) => (
            <article
              key={a.tag}
              className={`reveal reveal-${idx + 1} rounded-lg border border-background-200 bg-background-50 overflow-hidden`}
            >
              <div className="w-full aspect-[16/9] bg-background-100 overflow-hidden">
                <img
                  src={a.img}
                  alt={`91浏览器手机版 - ${a.tag}`}
                  title={`91浏览器 ${a.tag}`}
                  className="w-full h-full object-top"
                />
              </div>
              <div className="p-6 md:p-7">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center">
                    <i className={`${a.icon} text-xl`}></i>
                  </span>
                  <span className="text-xs font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full">
                    {a.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-heading font-bold text-xl md:text-2xl text-foreground-950">
                  {a.title}
                </h3>
                <ul className="mt-5 flex flex-col gap-3">
                  {a.points.map((p) => (
                    <li key={p} className="flex items-start gap-2.5 text-sm text-foreground-600">
                      <i className="ri-check-line text-base text-primary-500 mt-0.5"></i>
                      {p}
                    </li>
                  ))}
                </ul>
                <a
                  href="#download"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 cursor-pointer"
                >
                  去下载最新版安装包
                  <i className="ri-arrow-right-line text-base"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}